import type { VoiceTenantCallAggregate } from '@reach/shared-types/voice-agent-calls';
import { serializeCsvRow, type CsvCell } from '../../lib/csv-utils';

const VOICE_TENANT_CSV_HEADERS: CsvCell[] = [
  'tenant_name',
  'tenant_external_id',
  'total_calls',
  'transferred_calls',
  'transfer_rate_pct',
  'total_duration_secs',
  'avg_duration_secs',
  'usage_cost_usd',
  'sentiment_satisfied_pct',
];

export function buildVoiceTenantCsvLines(tenants: VoiceTenantCallAggregate[]): string[] {
  return [
    serializeCsvRow(VOICE_TENANT_CSV_HEADERS),
    ...tenants.map(tenant => {
      const transferRatePct =
        tenant.totalCalls > 0 ? (tenant.transferredCount / tenant.totalCalls) * 100 : 0;
      const classifiedSentimentTotal =
        tenant.sentimentPositive + tenant.sentimentNegative + tenant.sentimentNeutral;
      const satisfiedPct =
        classifiedSentimentTotal > 0
          ? ((tenant.sentimentPositive + tenant.sentimentNeutral) / classifiedSentimentTotal) * 100
          : 0;

      return serializeCsvRow([
        tenant.tenantName,
        tenant.tenantExternalId ?? '',
        tenant.totalCalls,
        tenant.transferredCount,
        transferRatePct.toFixed(1),
        tenant.totalDurationSecs ?? 0,
        tenant.avgDurationSecs ?? 0,
        (tenant.totalCostCents / 100).toFixed(2),
        satisfiedPct.toFixed(1),
      ]);
    }),
  ];
}

export function getVoiceCsvFilename(selectedDays: number): string {
  const now = new Date().toISOString().slice(0, 10);
  const filePeriod = selectedDays === 0 ? 'all-time' : `last-${selectedDays}d`;
  return `assist_tenant_usage_${filePeriod}_${now}.csv`;
}
